import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import { store, init } from "./Actions";
import { LangProvider } from "./i18n";

store.dispatch(init());

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* La langue enveloppe tout : la coque, la vue de jeu et les erreurs
          fatales en dependent, y compris avant l'initialisation du module. */}
      <LangProvider>
        <App />
      </LangProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
